import {getCustomSEO} from '../seo';
import {stripHTML} from '../../string.helper';

/**
 * Tạo SEO cho trang danh sách tin tức
 */
export function generateNewsListSEO(newsList, totalCount, webUrl) {
    const newsListUrl = `${webUrl}/tin-tuc`;

    // Tạo title
    const seoTitle = 'Tin tức y tế mới nhất | TNH Hospital';

    // Tạo description từ danh sách tin tức
    let seoDescription = '';
    if (newsList && Array.isArray(newsList) && newsList.length > 0) {
        // Lấy tên các tin tức chính (tối đa 4-5)
        const mainNews = newsList
            .slice(0, 5)
            .map(news => {
                const title = news.news_title || news.title || '';
                // Loại bỏ HTML tags và giới hạn độ dài
                return stripHTML(title, 50);
            })
            .filter(Boolean);

        const newsTitles = mainNews.join(', ');

        seoDescription = `Cập nhật tin tức y tế, sức khỏe mới nhất: ${newsTitles}${newsList.length > 5 ? ' và nhiều bài viết khác' : ''}. Thông tin về dịch vụ khám chữa bệnh, chuyên khoa, chăm sóc sức khỏe từ TNH Hospital.`;
    } else {
        seoDescription =
            'Tin tức y tế, sức khỏe mới nhất từ CTCP Tập đoàn Bệnh viện TNH. Cập nhật thông tin về dịch vụ khám chữa bệnh, chuyên khoa, chăm sóc sức khỏe chất lượng cao.';
    }

    // Giới hạn description
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Tạo keywords từ danh sách tin tức
    const keywordsParts = [];
    if (newsList && Array.isArray(newsList)) {
        // Lấy keywords từ các bài viết chính (tối đa 10)
        newsList.slice(0, 10).forEach(news => {
            // Thêm meta_key_words nếu có
            if (news.meta_key_words) {
                const keywords =
                    typeof news.meta_key_words === 'string' ? news.meta_key_words.split(',').map(k => k.trim()) : [];
                keywordsParts.push(...keywords);
            }

            // Thêm từ title
            const title = news.news_title || news.title || '';
            if (title) {
                const cleanTitle = stripHTML(title);
                // Lấy các từ quan trọng từ title (loại bỏ từ dài quá hoặc ngắn quá)
                const words = cleanTitle
                    .split(/\s+/)
                    .filter(
                        word =>
                            word.length > 3 &&
                            word.length < 20 &&
                            !['và', 'của', 'cho', 'với', 'từ', 'tại', 'theo'].includes(word.toLowerCase()),
                    )
                    .slice(0, 3);
                keywordsParts.push(...words);
            }

            // Thêm category name nếu có
            if (news.news_category_name && !keywordsParts.includes(news.news_category_name)) {
                keywordsParts.push(news.news_category_name);
            }
        });
    }

    // Thêm keywords mặc định
    keywordsParts.push(
        'Tin tức y tế',
        'Sức khỏe',
        'CTCP Tập đoàn Bệnh viện TNH',
        'Bệnh viện TNH',
        'Y tế',
        'Chăm sóc sức khỏe',
        'Khám chữa bệnh',
    );
    const seoKeywords = [...new Set(keywordsParts)].join(', '); // Loại bỏ duplicate

    // Xử lý image - lấy ảnh từ tin tức đầu tiên hoặc dùng default
    let seoImage = '';
    if (newsList && Array.isArray(newsList) && newsList.length > 0) {
        const firstNews = newsList.find(news => news.image_url || news.banner_url || news.picture_url);
        if (firstNews) {
            seoImage = firstNews.image_url || firstNews.banner_url || firstNews.picture_url || '';
            if (Array.isArray(seoImage)) {
                seoImage = seoImage[0] || '';
            }
            // Đảm bảo URL đầy đủ
            if (seoImage && !seoImage.startsWith('http://') && !seoImage.startsWith('https://')) {
                seoImage = seoImage.startsWith('/') ? `${webUrl}${seoImage}` : `${webUrl}/${seoImage}`;
            }
        }
    }

    return getCustomSEO(seoTitle, seoDescription, newsListUrl, seoKeywords, seoImage);
}

/**
 * Tạo SEO cho trang danh sách ưu đãi
 */
export function generatePromotionListSEO(promotions, webUrl) {
    const promotionListUrl = `${webUrl}/uu-dai`;

    // Tạo title
    const seoTitle = 'Ưu đãi & Khuyến mãi | CTCP Tập đoàn Bệnh viện TNH';

    // Tạo description từ danh sách ưu đãi
    let seoDescription = '';
    if (promotions && Array.isArray(promotions) && promotions.length > 0) {
        // Lấy tên các ưu đãi chính (tối đa 4-5)
        const mainPromotions = promotions
            .slice(0, 5)
            .map(promo => {
                const title = promo.news_title || promo.title || '';
                // Loại bỏ HTML tags nếu có
                return stripHTML(title, 50);
            })
            .filter(Boolean);

        const promotionTitles = mainPromotions.join(', ');
        const totalCount = promotions.length;

        seoDescription = `CTCP Tập đoàn Bệnh viện TNH - ${totalCount} chương trình ưu đãi, khuyến mãi đặc biệt: ${promotionTitles}${totalCount > 5 ? ' và nhiều ưu đãi khác' : ''}. Giảm giá, tặng quà, gói khám ưu đãi. Xem ngay và đặt lịch khám.`;
    } else {
        seoDescription =
            'Chương trình ưu đãi và khuyến mãi đặc biệt tại CTCP Tập đoàn Bệnh viện TNH. Giảm giá, tặng quà, gói khám ưu đãi. Xem ngay và đặt lịch khám để nhận ưu đãi tốt nhất.';
    }

    // Giới hạn description
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Tạo keywords từ danh sách ưu đãi
    const keywordsParts = [];
    if (promotions && Array.isArray(promotions)) {
        // Lấy tên các ưu đãi chính (tối đa 8)
        promotions.slice(0, 8).forEach(promo => {
            const title = promo.news_title || promo.title || '';
            if (title) {
                const cleanTitle = stripHTML(title);
                // Loại bỏ các từ dài quá và lấy keywords từ title
                const words = cleanTitle
                    .split(/\s+/)
                    .filter(word => word.length > 2 && word.length < 20)
                    .slice(0, 3);
                keywordsParts.push(...words);
            }
        });
    }
    keywordsParts.push('Ưu đãi', 'Khuyến mãi', 'TNH', 'Bệnh viện TNH', 'Giảm giá', 'Gói khám ưu đãi', 'Đặt lịch khám');
    const seoKeywords = [...new Set(keywordsParts)].join(', '); // Loại bỏ duplicate

    // Xử lý image - lấy ảnh từ ưu đãi đầu tiên hoặc dùng default
    let seoImage = '';
    if (promotions && Array.isArray(promotions) && promotions.length > 0) {
        const firstPromo = promotions.find(promo => promo.image_url || promo.picture_url);
        if (firstPromo) {
            seoImage = firstPromo.image_url || firstPromo.picture_url || '';
            if (Array.isArray(seoImage)) {
                seoImage = seoImage[0] || '';
            }
            // Đảm bảo URL đầy đủ
            if (seoImage && !seoImage.startsWith('http://') && !seoImage.startsWith('https://')) {
                seoImage = seoImage.startsWith('/') ? `${webUrl}${seoImage}` : `${webUrl}/${seoImage}`;
            }
        }
    }

    return getCustomSEO(seoTitle, seoDescription, promotionListUrl, seoKeywords, seoImage);
}

/**
 * Tạo SEO cho trang danh sách báo chí nói về TNH
 */
export function generatePressListSEO(pressArticles, totalCount, webUrl) {
    const pressListUrl = `${webUrl}/bao-chi-noi-ve-tnh`;

    // Tạo title
    const seoTitle =
        totalCount && totalCount > 0
            ? `Báo chí nói về TNH - ${totalCount} bài viết | CTCP Tập đoàn Bệnh viện TNH`
            : 'Báo chí nói về TNH | CTCP Tập đoàn Bệnh viện TNH';

    // Tạo description từ danh sách bài viết báo chí
    let seoDescription = '';
    if (pressArticles && Array.isArray(pressArticles) && pressArticles.length > 0) {
        // Lấy tên các bài viết chính (tối đa 4-5)
        const mainArticles = pressArticles
            .slice(0, 5)
            .map(article => {
                const title = article.news_title || article.title || '';
                // Loại bỏ HTML tags và giới hạn độ dài
                return stripHTML(title, 50);
            })
            .filter(Boolean);

        const articleTitles = mainArticles.join(', ');
        const count = totalCount || pressArticles.length;

        seoDescription = `Tổng hợp ${count} bài báo, tin tức báo chí viết về CTCP Tập đoàn Bệnh viện TNH: ${articleTitles}${count > 5 ? ' và nhiều bài viết khác' : ''}. Cập nhật tin tức, đánh giá, nhận xét của báo chí về bệnh viện TNH.`;
    } else {
        seoDescription =
            'Tổng hợp các bài báo, tin tức báo chí viết về CTCP Tập đoàn Bệnh viện TNH. Cập nhật tin tức, đánh giá, nhận xét của báo chí về bệnh viện TNH, dịch vụ y tế và chăm sóc sức khỏe.';
    }

    // Giới hạn description
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Tạo keywords từ danh sách bài viết
    const keywordsParts = [];
    if (pressArticles && Array.isArray(pressArticles)) {
        // Lấy keywords từ các bài viết chính (tối đa 10)
        pressArticles.slice(0, 10).forEach(article => {
            // Thêm meta_key_words nếu có
            if (article.meta_key_words) {
                const keywords =
                    typeof article.meta_key_words === 'string'
                        ? article.meta_key_words.split(',').map(k => k.trim())
                        : [];
                keywordsParts.push(...keywords);
            }

            // Thêm từ title
            const title = article.news_title || article.title || '';
            if (title) {
                const cleanTitle = stripHTML(title);
                // Lấy các từ quan trọng từ title
                const words = cleanTitle
                    .split(/\s+/)
                    .filter(
                        word =>
                            word.length > 3 &&
                            word.length < 20 &&
                            !['và', 'của', 'cho', 'với', 'từ', 'tại', 'theo', 'về'].includes(word.toLowerCase()),
                    )
                    .slice(0, 3);
                keywordsParts.push(...words);
            }

            // Thêm category name nếu có
            if (article.news_category_name && !keywordsParts.includes(article.news_category_name)) {
                keywordsParts.push(article.news_category_name);
            }
        });
    }

    // Thêm keywords mặc định cho báo chí
    keywordsParts.push(
        'Báo chí nói về TNH',
        'Tin tức TNH',
        'Bệnh viện TNH',
        'CTCP Tập đoàn Bệnh viện TNH',
        'Báo chí y tế',
        'Tin tức y tế',
        'Đánh giá bệnh viện',
    );
    const seoKeywords = [...new Set(keywordsParts)].join(', '); // Loại bỏ duplicate

    // Xử lý image - lấy ảnh từ bài viết đầu tiên hoặc dùng default
    let seoImage = '';
    if (pressArticles && Array.isArray(pressArticles) && pressArticles.length > 0) {
        const firstArticle = pressArticles.find(
            article => article.image_url || article.banner_url || article.picture_url,
        );
        if (firstArticle) {
            seoImage = firstArticle.image_url || firstArticle.banner_url || firstArticle.picture_url || '';
            if (Array.isArray(seoImage)) {
                seoImage = seoImage[0] || '';
            }
            // Đảm bảo URL đầy đủ
            if (seoImage && !seoImage.startsWith('http://') && !seoImage.startsWith('https://')) {
                seoImage = seoImage.startsWith('/') ? `${webUrl}${seoImage}` : `${webUrl}/${seoImage}`;
            }
        }
    }

    return getCustomSEO(seoTitle, seoDescription, pressListUrl, seoKeywords, seoImage);
}

/**
 * Tạo SEO cho trang chi tiết tin tức
 */
export function generateNewsSEO(newsDetail, slug, webUrl) {
    const newsUrl = `${webUrl}/${slug}`;

    const seoTitle = newsDetail?.news_title ? `${newsDetail.news_title} | CTCP Tập đoàn Bệnh viện TNH` : 'Tin tức TNH';

    let seoDescription = '';
    if (newsDetail?.short_description) {
        seoDescription = stripHTML(newsDetail.short_description, 160);
    } else if (newsDetail?.meta_description) {
        seoDescription = stripHTML(newsDetail.meta_description, 160);
    }

    // Nếu description quá ngắn (< 120), mở rộng với thông tin bổ sung
    if (seoDescription && seoDescription.length < 120) {
        if (newsDetail?.news_title) {
            seoDescription = `${seoDescription} Đọc bài viết "${newsDetail.news_title}" - Tin tức y tế, sức khỏe mới nhất từ CTCP Tập đoàn Bệnh viện TNH.`;
        } else {
            seoDescription = `${seoDescription} Tin tức y tế, sức khỏe mới nhất từ CTCP Tập đoàn Bệnh viện TNH. Cập nhật thông tin về dịch vụ khám chữa bệnh, chuyên khoa và chăm sóc sức khỏe.`;
        }
        if (seoDescription.length > 160) {
            seoDescription = seoDescription.substring(0, 157) + '...';
        }
    }

    if (!seoDescription && newsDetail?.news_title) {
        seoDescription = `Đọc bài viết "${newsDetail.news_title}" - Tin tức y tế, sức khỏe mới nhất từ CTCP Tập đoàn Bệnh viện TNH. Cập nhật thông tin về dịch vụ khám chữa bệnh chất lượng cao.`;
    } else if (!seoDescription) {
        seoDescription =
            'Tin tức y tế, sức khỏe mới nhất từ CTCP Tập đoàn Bệnh viện TNH. Cập nhật thông tin về dịch vụ khám chữa bệnh, chuyên khoa và chăm sóc sức khỏe chất lượng cao.';
    }

    // Tối ưu keywords - thêm nhiều từ khóa liên quan
    // Lưu ý: API trả về meta_key_words (không phải meta_keywords)
    const keywordsParts = [];
    if (newsDetail?.meta_key_words) {
        keywordsParts.push(newsDetail.meta_key_words);
    } else if (newsDetail?.meta_keywords) {
        // Fallback nếu có meta_keywords
        keywordsParts.push(newsDetail.meta_keywords);
    }
    if (newsDetail?.news_title) {
        keywordsParts.push(newsDetail.news_title);
    }
    keywordsParts.push('Tin tức y tế', 'CTCP Tập đoàn Bệnh viện TNH', 'Sức khỏe', 'Y tế');
    if (newsDetail?.news_category_name) {
        keywordsParts.push(newsDetail.news_category_name);
    }

    const seoKeywords = keywordsParts.join(', ');

    // Xử lý image - có thể là array hoặc string
    let seoImage = '';
    if (newsDetail?.image_url) {
        seoImage = Array.isArray(newsDetail.image_url) ? newsDetail.image_url[0] || '' : newsDetail.image_url;
    }
    if (!seoImage && newsDetail?.banner_url) {
        seoImage = Array.isArray(newsDetail.banner_url) ? newsDetail.banner_url[0] || '' : newsDetail.banner_url;
    }

    return getCustomSEO(seoTitle, seoDescription, newsUrl, seoKeywords, seoImage);
}
